import { batch } from 'react-redux';
import { STATUS_LOADING } from 'common/constants';
import { getResponseError } from 'common/utils/index';

import { countriesAPI } from 'entities/countries';
import { roadsideServicesAPI } from 'entities/roadsideServices';
import { stationsAPI } from 'entities/stations';
import { servicesAPI } from 'entities/services';
import { dimensionsAPI } from 'entities/dimensions';
import { brandsAPI } from 'entities/brands';
import { paymentsAPI } from 'entities/payments';

import { Country } from 'entities/countries';
import { RoadsideService } from 'entities/roadsideServices';
import { StationCategory } from 'entities/stations';
import { ServiceFormat, AdditionalService } from 'entities/services';
import { DimensionLimitation } from 'entities/dimensions';
import { Service } from 'entities/services';
import { PaymentType } from 'entities/payments';
import { CountryBrands } from 'entities/brands';
import Promise from 'core-js-pure/actual/promise';

import { AxiosResponse } from 'axios';

import slice from '../reducer/slice';
import { applicationActions } from 'entities/application';

const { statusLoading, initDirectories } = slice.actions;
const { setErrorNotice } = applicationActions;
interface PromiseResultItem<T> {
  value?: T
}

type PromiseResult = [
  PromiseResultItem<AxiosResponse<Country[]>>,
  PromiseResultItem<AxiosResponse<RoadsideService[]>>,
  PromiseResultItem<AxiosResponse<StationCategory[]>>,
  PromiseResultItem<AxiosResponse<ServiceFormat[]>>,
  PromiseResultItem<AxiosResponse<DimensionLimitation[]>>,
  PromiseResultItem<AxiosResponse<Service[]>>,
  PromiseResultItem<AxiosResponse<AdditionalService[]>>,
  PromiseResultItem<AxiosResponse<{ countries: CountryBrands[] }>>,
  PromiseResultItem<AxiosResponse<PaymentType[]>>
];

const operation = () => async (dispatch: any) => {
  try {
    dispatch(statusLoading(STATUS_LOADING.load));

    const [
      { value: { data: countries = [] } = {} },
      { value: { data: roadsideService = [] } = {} },
      { value: { data: stationCategories = [] } = {} },
      { value: { data: serviceFormats = [] } = {} },
      { value: { data: additionalParams = [] } = {} },
      { value: { data: services = [] } = {} },
      { value: { data: additionalServices = [] } = {} },
      { value: { data: countriesBrands = { countries: [] } } = {} },
      { value: { data: paymentTypes = [] } = {} }
    ] = await Promise.allSettled([
      countriesAPI.getCountries(),
      roadsideServicesAPI.getRoadsideServices(),
      stationsAPI.getStationCategories(),
      servicesAPI.getServiceFormats(),
      dimensionsAPI.getDimensionsLimitation(),
      servicesAPI.getServices(),
      servicesAPI.getAdditionalServices(),
      brandsAPI.getCountriesBrands({ countryAlpha2Codes: [] }),
      paymentsAPI.getPaymentTypes()
    ]) as PromiseResult;

    batch(() => {
      dispatch(statusLoading(STATUS_LOADING.done));
      dispatch(
        initDirectories({
          countries,
          roadsideService,
          stationCategories,
          serviceFormats,
          additionalParams,
          services,
          additionalServices,
          countriesBrands,
          paymentTypes
        })
      );
    });
  } catch (e) {
    const error = await getResponseError(e);
    dispatch(setErrorNotice(error));
    dispatch(statusLoading(STATUS_LOADING.error));
  }
};

export default operation;
